module.exports = __webpack_public_path__ + "static/media/gryphon-house-kitchen-living.59ac516e.jpg";